import { ErrorProps } from '../../components/notify';
import { FileProps } from '../../types/common-types';
// This file holds our state type, as well as any other types related to this Redux store.

// Response object for POST /get
export interface PageProps {
  grid: object;
  forms: object[];
}

export interface SessioDataProps {
  auth?: boolean;
}

// Use `enum`s for better autocompletion of action type names. These will
// be compiled away leaving only the final value in your compiled code.
//
// Define however naming conventions you'd like for your action types, but
// personally, I use the `@@context/ACTION_TYPE` convention, to follow the convention
// of Redux's `@@INIT` action.
export enum PageActionTypes {
  LOCATION_CHANGE = '@@router/LOCATION_CHANGE',
  PAGE_REQUEST = '@@router/PAGE_REQUEST',
  PAGE_SUCCESS = '@@page/PAGE_SUCCESS',
  PAGE_ERROR = '@@page/PAGE_ERROR',
  CLEAR_FORMS = '@@page/CLEAR_FORMS',
  UPDATE_ITEM_REQUEST = '@@page/UPDATE_ITEM_REQUEST',
  UPDATE_ITEM_SUCCESS = '@@page/UPDATE_ITEM_SUCCESS',
  SUBMIT_FORM_REQUEST = '@@page/SUBMIT_FORM_REQUEST',
  SUBMIT_FORM_SUCCESS = '@@page/SUBMIT_FORM_SUCCESS',
  SET_SUBMIT_BUTTON_ID = '@@page/SET_SUBMIT_BUTTON_ID',
  UNSET_SUBMIT_BUTTON_ID = '@@page/UNSET_SUBMIT_BUTTON_ID',
  PAGE_LOGOUT_REQUEST = '@@page/PAGE_LOGOUT_REQUEST',
  PREVIEW_FILE = '@@page/PREVIEW_FILE',
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface PageState {
  readonly loading: boolean;
  readonly previewFile?: FileProps;
  readonly submitingButtonId: string;
  readonly data: PageProps;
  readonly sessionData: SessioDataProps;
  readonly errors?: Array<ErrorProps>;
}
